


export const formatMixin = {


	methods: {

		timeSince(string) {

			if (!string){
				return "??";
			}

			string = string?.replace(" ", "T");
			const date = new Date(string);



			var seconds = Math.floor((new Date() - date) / 1000);

			var interval = seconds / 31536000;

			if (interval > 1) {
				const years = Math.floor(interval); 
				if (years == 1){
					return "Ett år"
				}
				return  years + " år";
			}
			interval = seconds / 2592000;
			if (interval > 1) {
				const month = Math.floor(interval)
				if (month == 1){
					return "En månad";
				}
				return month + " månader";
			}
			interval = seconds / 86400;
			if (interval > 1) {
				const days = Math.floor(interval);
				if (days == 1){
					return "En dag";
				} 
				return days + " dagar";
			}
			interval = seconds / 3600;
			if (interval > 1) {
				const hours = Math.floor(interval)
				if (hours == 1){
					return "En timme"
				}
				return hours + " timmar";
			}
			interval = seconds / 60;
			if (interval > 1) {
				const minutes = Math.floor(interval)
				if (minutes == 1){
					return "En minut"
				}
				return minutes + " minuter";
			}

			return "Nu" 

			//return Math.floor(seconds) + " seconds";
		},

		





	}
}



